import { Component, Inject, Renderer2 } from '@angular/core';
import {
  MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA,
  MatLegacySnackBarRef as MatSnackBarRef,
} from '@angular/material/legacy-snack-bar';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
})
export class SnackBarComponent {
  // 찜한 여행(위시리스트) 화면은 공개 사이트(Next.js)로 이전됨
  openWishlist(): void {
    window.open(`${environment.webDomain}/tabs/my-like-product`, 'nnb-web');
  }

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private snackRef: MatSnackBarRef<SnackBarComponent>,
    private ren: Renderer2,
  ) {
    setTimeout(() => {
      let snackEl = document.getElementsByClassName('mat-snack-bar-container').item(0);
      this.ren.listen(snackEl, 'click', () => {
        this.snackRef.dismiss();
      });
    });
  }
}
